import { Component, OnInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { SellerApiService } from '../../../service/seller-api.service';

@Component({
  selector: 'app-kitchen-attach-browse',
  templateUrl: './kitchen-attach-browse.component.html',
  styleUrls: ['./kitchen-attach-browse.component.scss']
})
export class KitchenAttachBrowseComponent implements OnInit, OnChanges {

  @Input() uploadlinks: Array<any>;
  upload_links: Array<any> = [];
  constructor(private sellerService: SellerApiService) { }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    this.upload_links  = [];
    if (typeof this.uploadlinks !== 'undefined') {
      if (Array.isArray(this.uploadlinks)) {
        this.upload_links = this.uploadlinks;
      } else {
        this.upload_links = String(this.uploadlinks).split(',');
      }
    }
  }

     // Get the Thummail
  getFileThumail(url) {
    // tslint:disable-next-line:prefer-const
    let extension = url.split('.').splice(-1)[0].toLocaleLowerCase();
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif' || extension === 'svg') {
      return url;
    }
    let mainFileType = this.sellerService.getMainFileType(extension);
    if (mainFileType == null) {
      if (extension === 'mp3' || extension === 'ogg' || extension === 'wav'
        || extension === 'webm' || extension === 'mmf' || extension === 'm4p' || extension === 'msv') {
        mainFileType = 'audio';
      } else if (extension === 'flv'
        || extension === 'mov' || extension === 'mp4' || extension === 'avi' || extension === 'mpeg' || extension === 'wmv') {
        mainFileType = 'video';
      } else {
        mainFileType = 'other';
      }
      return this.sellerService.getThumbnailImages(mainFileType, url);
    } else {
      return this.sellerService.getThumbnailImages(mainFileType, url);
    }

  }

    getFileNameSplit(url) {
      // tslint:disable-next-line:prefer-const
      let value = url.split('_X_').pop();
      return value;
    }

}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/kitchen/kitchen-attach-browse/kitchen-attach-browse.component.ts